export const NO_PIN_ERROR = 'ERROR-NO_PIN';
